<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-6 offset-md-3 offset-md-3 mt-5">
                <app-card :title="$t('Verify email')">
                    <template v-if="success">
                        <div class="alert alert-success" role="alert">
                            {{ status }}
                        </div>

                        <router-link :to="{ name: 'login' }" class="btn btn-primary" exact>
                            {{ $t('Log in') }}
                        </router-link>
                    </template>
                    <template v-else>
                        <div class="alert alert-danger" role="alert">
                            {{ status || $t('Failed to verify email') }}
                        </div>

                        <router-link :to="{ name: 'verification.resend' }" class="btn btn-outline-info btn-sm ml-2" exact>
                            {{ $t('Resend verification link') }}
                        </router-link>
                    </template>
                </app-card>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
const qs = params => Object.keys(params).map(key => `${key}=${params[key]}`).join('&');

export default {
    async asyncData({ params, query }) {
        try {
            const { data } = await axios.post(`/email/verify/${params.id}?${qs(query)}`);

            return { success: true, status: data.status };
        } catch (e) {
            return { success: false, status: e.response.data.status };
        }
    }
};
</script>
